import type { RouteRecordRaw } from 'vue-router'

interface ModuleRecord {
  [key: string]: RouteRecordRaw
}

let modules: RouteRecordRaw[] = [];
const modulesFiles = import.meta.glob("./*.ts", { eager: true });
let obj: ModuleRecord = {};
Object.keys(modulesFiles).reduce((modules, path) => {
  const moduleName = path.replace(/^\.\/(.*)\.\w+$/, "$1");
  const moduleDefault = (modulesFiles[path] as any)?.default;
  if (moduleDefault) {
    obj[moduleName] = moduleDefault;
  }
  return obj;
}, {});
modules = Object.values(obj);

export default modules;
